import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import { Link } from 'react-router-dom';
import { BookIcon, CalendarIcon, MapPinIcon, UserIcon, LandmarkIcon, GraduationCapIcon, HeartIcon, UsersIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const IslamicReligion = () => {
  const chiefImams = [{
    name: 'Pa Abdul Salami',
    origin: 'from Idotun Rattibi',
    period: '1908 – 1944'
  }, {
    name: 'Pa Alli Balogun',
    origin: 'from Itun Ogun',
    period: '1944 – 1949'
  }, {
    name: 'Alhaji Ibrahim Akeusola',
    origin: 'Itu Isonyin',
    period: '1950 – 1987'
  }, {
    name: 'Alhaji Anifata A. Bakare',
    origin: 'from Idotun',
    period: '1988 – 2009'
  }, {
    name: 'Alhaji Hussein Kehinde Akeusola',
    origin: '',
    period: '2009 – 2025'
  }, {
    name: 'Alfa Shakiru Zubair',
    origin: '',
    period: '2025 Till Date'
  }];
  const mosqueMilestones = [{
    event: 'First Isonyin Central Mosque commissioned',
    year: '1908'
  }, {
    event: 'Second Central Mosque construction began',
    year: '1911'
  }, {
    event: 'Second Central Mosque commissioned',
    year: '1928'
  }, {
    event: 'Fund raising for third Central Mosque',
    year: 'December 1997'
  }, {
    event: 'Foundation laying ceremony for third Central Mosque',
    year: 'July 1998'
  }, {
    event: 'Third Central Mosque commissioned',
    year: 'July 23rd, 2016'
  }];
  return <div className="min-h-screen bg-white" data-id="element-3781">
      <PageHeader title="Islamic Religion in Isonyin" description="The history and development of Islam in Isonyin community." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/oSfxzNf98Rax9zCFb6ybcB/WhatsApp_Image_2025-11-07_at_19.20.07.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'About',
      path: '/about'
    }, {
      label: 'Islamic Religion',
      path: '/islamic-religion'
    }]} data-id="element-3782" />
      <div className="container mx-auto px-4 py-12" data-id="element-3783">
        {/* Mosque Photo Gallery Section */}
        <section className="mb-16" data-id="element-3784">
          <div className="text-center mb-10" data-id="element-3785">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3786">
              Isonyin Central Mosque
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3787"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-3788">
              A magnificent testament to the faith and dedication of the Muslim
              community in Isonyin
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-3789">
            <div className="relative overflow-hidden rounded-lg shadow-xl group" data-id="element-3790">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/t8G9CzciASfCeNchUAs1Rz/WhatsApp_Image_2025-11-07_at_19.20.07_%281%29.jpg" alt="Isonyin Central Mosque - Twin Minarets and Dome" className="w-full h-96 object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-3791" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-green-900/90 to-transparent p-6" data-id="element-3792">
                <p className="text-white font-bold text-lg" data-id="element-3793">
                  The Majestic Twin Minarets
                </p>
                <p className="text-white/90 text-sm" data-id="element-3794">
                  Distinctive architectural features of the Central Mosque
                </p>
              </div>
            </div>
            <div className="relative overflow-hidden rounded-lg shadow-xl group" data-id="element-3795">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oSfxzNf98Rax9zCFb6ybcB/WhatsApp_Image_2025-11-07_at_19.20.07.jpg" alt="Isonyin Central Mosque - Full View" className="w-full h-96 object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-3796" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-green-900/90 to-transparent p-6" data-id="element-3797">
                <p className="text-white font-bold text-lg" data-id="element-3798">
                  The Modern Central Mosque
                </p>
                <p className="text-white/90 text-sm" data-id="element-3799">
                  Commissioned in 2016, serving the Muslim community
                </p>
              </div>
            </div>
          </div>
          <div className="relative overflow-hidden rounded-lg shadow-xl" data-id="element-3800">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wuqRSyBEBkUSFG6B3VJfeB/WhatsApp_Image_2025-11-07_at_19.20.06.jpg" alt="Historical Mosque Building in Isonyin" className="w-full h-[500px] object-cover" data-id="element-3801" />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-green-900/95 to-transparent p-8" data-id="element-3802">
              <p className="text-white font-bold text-2xl mb-2" data-id="element-3803">
                Historical Mosque Structure
              </p>
              <p className="text-white/90" data-id="element-3804">
                One of the earlier mosque buildings that served the Isonyin
                Muslim community, showcasing the evolution of Islamic
                architecture in the town
              </p>
            </div>
          </div>
        </section>
        {/* Introduction Section */}
        <section className="mb-16" data-id="element-3805">
          <div className="text-center mb-10" data-id="element-3806">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3807">
              Islam in Isonyin
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3808"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-3809">
            <div data-id="element-3810">
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-3811">
                Isonyin was founded about the middle of the 18th Century by one
                of the Princesses of the 39th Awujale of Ijebuland, His Royal
                Highness, Gbelegbuwa I. Located 10 kilometres North-East of
                Ijebu-Ode in Ogun State of Nigeria, the town is renowned for a
                remarkably high level of literacy and a near absence of
                traditional religion.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-3812">
                The town has had four generations of educated population and
                today, has a minimum average of three graduates per household.
                Islam and Christianity are the two primary religious faiths,
                with traditional worship being almost negligible.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-3813">
                Politically, Isonyin is an important administrative centre.
                During the second republic, it served as the headquarters of the
                then Yemoji Local Government Area. It is now an important
                component of the new Ijebu North East Local Government. The town
                has a population of about 30,000 people, 25% of whom are
                Muslims.
              </p>
            </div>
            <div className="bg-blue-50 p-8 rounded-lg shadow-md" data-id="element-3814">
              <h3 className="text-xl font-bold text-blue-900 mb-4 flex items-center" data-id="element-3815">
                <MapPinIcon className="mr-2 h-6 w-6 text-blue-700" data-id="element-3816" />
                Isonyin at a Glance
              </h3>
              <ul className="space-y-4" data-id="element-3817">
                <li className="flex items-start" data-id="element-3818">
                  <div className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-3819">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3820">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3821" />
                    </svg>
                  </div>
                  <div data-id="element-3822">
                    <span className="font-bold" data-id="element-3823">Founded:</span> Mid-18th Century
                    by a Princess of Awujale Gbelegbuwa I
                  </div>
                </li>
                <li className="flex items-start" data-id="element-3824">
                  <div className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-3825">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3826">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3827" />
                    </svg>
                  </div>
                  <div data-id="element-3828">
                    <span className="font-bold" data-id="element-3829">Location:</span> 10km North-East
                    of Ijebu-Ode, Ogun State
                  </div>
                </li>
                <li className="flex items-start" data-id="element-3830">
                  <div className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-3831">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3832">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3833" />
                    </svg>
                  </div>
                  <div data-id="element-3834">
                    <span className="font-bold" data-id="element-3835">Population:</span> Approximately
                    30,000 people
                  </div>
                </li>
                <li className="flex items-start" data-id="element-3836">
                  <div className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-3837">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3838">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3839" />
                    </svg>
                  </div>
                  <div data-id="element-3840">
                    <span className="font-bold" data-id="element-3841">Religious Distribution:</span>{' '}
                    25% Muslims, 75% Christians
                  </div>
                </li>
                <li className="flex items-start" data-id="element-3842">
                  <div className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-3843">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3844">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3845" />
                    </svg>
                  </div>
                  <div data-id="element-3846">
                    <span className="font-bold" data-id="element-3847">Education:</span> High literacy
                    rate with an average of three graduates per household
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>
        {/* History of Religion Section */}
        <section className="mb-16" data-id="element-3848">
          <div className="text-center mb-10" data-id="element-3849">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3850">
              Religious History of Isonyin
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3851"></div>
          </div>
          <div className="bg-green-50 p-8 rounded-lg shadow-md mb-12" data-id="element-3852">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-3853">
              <div data-id="element-3854">
                <h3 className="text-xl font-bold text-green-800 mb-4 flex items-center" data-id="element-3855">
                  <HeartIcon className="mr-2 h-6 w-6 text-green-700" data-id="element-3856" />
                  The Arrival of Religions
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-3857">
                  Until 1894 when the Christian faith was introduced, the
                  Isonyin people like their compatriots elsewhere in Ijebuland
                  were idol worshippers. The new faith grew rapidly that the
                  building of the first church commenced in 1898. It was
                  dedicated in 1901. A Christian primary school was also founded
                  by the church mission in 1897.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-3858">
                  Islam was introduced to Isonyin a few years after
                  Christianity. The fact of the earlier arrival of Christianity
                  in town, the perceived relative ease of worship and the new
                  sophistication arising from the introduction of literacy
                  instruction by the church mission, gave Christianity a
                  significant head-start advantage. This advantage has reflected
                  over the years in the 75% to 25% ratio between the two
                  religions.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-3859">
                <h3 className="text-xl font-bold text-green-800 mb-4" data-id="element-3860">
                  Timeline of Religious Development
                </h3>
                <ul className="space-y-3" data-id="element-3861">
                  <li className="flex items-start" data-id="element-3862">
                    <div className="flex-shrink-0 w-20 font-bold text-green-700" data-id="element-3863">
                      Pre-1894
                    </div>
                    <div className="flex-grow pl-4 border-l-2 border-green-200" data-id="element-3864">
                      <p className="text-gray-700" data-id="element-3865">
                        Traditional worship was predominant in Isonyin
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-3866">
                    <div className="flex-shrink-0 w-20 font-bold text-green-700" data-id="element-3867">
                      1894
                    </div>
                    <div className="flex-grow pl-4 border-l-2 border-green-200" data-id="element-3868">
                      <p className="text-gray-700" data-id="element-3869">
                        Introduction of Christianity to Isonyin
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-3870">
                    <div className="flex-shrink-0 w-20 font-bold text-green-700" data-id="element-3871">
                      1897
                    </div>
                    <div className="flex-grow pl-4 border-l-2 border-green-200" data-id="element-3872">
                      <p className="text-gray-700" data-id="element-3873">
                        Christian primary school founded by church mission
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-3874">
                    <div className="flex-shrink-0 w-20 font-bold text-green-700" data-id="element-3875">
                      Late 1890s
                    </div>
                    <div className="flex-grow pl-4 border-l-2 border-green-200" data-id="element-3876">
                      <p className="text-gray-700" data-id="element-3877">
                        Introduction of Islam to Isonyin
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-3878">
                    <div className="flex-shrink-0 w-20 font-bold text-green-700" data-id="element-3879">
                      1908
                    </div>
                    <div className="flex-grow pl-4 border-l-2 border-green-200" data-id="element-3880">
                      <p className="text-gray-700" data-id="element-3881">
                        First Chief Imam appointed and first Central Mosque
                        commissioned
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-3882">
                    <div className="flex-shrink-0 w-20 font-bold text-green-700" data-id="element-3883">
                      1955
                    </div>
                    <div className="flex-grow pl-4 border-l-2 border-green-200" data-id="element-3884">
                      <p className="text-gray-700" data-id="element-3885">
                        Erodo Moslem Primary School established
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-3886">
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 hover:shadow-lg transition-shadow" data-id="element-3887">
              <div className="flex items-center mb-4" data-id="element-3888">
                <div className="bg-green-100 p-3 rounded-full mr-4" data-id="element-3889">
                  <LandmarkIcon className="h-6 w-6 text-green-700" data-id="element-3890" />
                </div>
                <h3 className="text-xl font-bold text-blue-900" data-id="element-3891">
                  Traditional Religion
                </h3>
              </div>
              <p className="text-gray-700" data-id="element-3892">
                Before the introduction of Abrahamic religions, Isonyin people
                practiced traditional worship like other communities in
                Ijebuland. Today, traditional religion is almost negligible in
                the community.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 hover:shadow-lg transition-shadow" data-id="element-3893">
              <div className="flex items-center mb-4" data-id="element-3894">
                <div className="bg-green-100 p-3 rounded-full mr-4" data-id="element-3895">
                  <BookIcon className="h-6 w-6 text-green-700" data-id="element-3896" />
                </div>
                <h3 className="text-xl font-bold text-blue-900" data-id="element-3897">
                  Christianity
                </h3>
              </div>
              <p className="text-gray-700" data-id="element-3898">
                Christianity arrived in 1894 and grew rapidly, leading to the
                construction of the first church in 1898. The religion gained
                advantage through early establishment of schools and literacy
                programs.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 hover:shadow-lg transition-shadow" data-id="element-3899">
              <div className="flex items-center mb-4" data-id="element-3900">
                <div className="bg-green-100 p-3 rounded-full mr-4" data-id="element-3901">
                  <BookIcon className="h-6 w-6 text-green-700" data-id="element-3902" />
                </div>
                <h3 className="text-xl font-bold text-blue-900" data-id="element-3903">Islam</h3>
              </div>
              <p className="text-gray-700" data-id="element-3904">
                Islam was introduced shortly after Christianity. Despite being
                the minority faith, Muslims in Isonyin became a center for
                Islamic activities in the region, serving neighboring towns and
                villages.
              </p>
            </div>
          </div>
        </section>
        {/* Islamic Growth Section */}
        <section className="mb-16" data-id="element-3905">
          <div className="text-center mb-10" data-id="element-3906">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3907">
              The Growth of Islam in Isonyin
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3908"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-3909">
            <div data-id="element-3910">
              <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-3911">
                A Center of Islamic Propagation
              </h3>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-3912">
                The early Muslims did not see their relatively low number as a
                disadvantage. They took it as a challenge to propagate the faith
                to the neighbouring towns and villages. The crusade yielded
                fruitful dividends in the large number of converts won in these
                places.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-3913">
                Consequently, Isonyin became the nerve centre of Islamic
                activities in the area. It was for many years to follow, the
                venue for Jumat services and Eid prayers for Muslims from some
                twenty neighbouring towns and villages. Soon the need arose to
                build a central mosque. Its construction began in 1909 and it
                was dedicated in 1911.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-3914">
                The shortcomings of the existing Central Mosque became even more
                glaring when because of our laudable role in the relentless
                propagation of Islam, Isonyin was designated the head-quarters
                of the league of Chief Imams of 60 towns in Yemoji Local
                Government Area of Ogun State. The constitution of the
                association enjoins them to observe at least one Jumat service
                in Isonyin per month.
              </p>
            </div>
            <div data-id="element-3915">
              <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 mb-6" data-id="element-3916">
                <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-3917">
                  Central Mosque Development
                </h3>
                <div className="space-y-4" data-id="element-3918">
                  {mosqueMilestones.map((milestone, index) => <div key={index} className="flex items-start" data-id="element-3919">
                      <CalendarIcon className="h-5 w-5 text-green-700 mr-2 mt-0.5" data-id="element-3920" />
                      <div data-id="element-3921">
                        <span className="font-bold" data-id="element-3922">{milestone.year}:</span>{' '}
                        {milestone.event}
                      </div>
                    </div>)}
                </div>
              </div>
              <div className="bg-green-50 p-6 rounded-lg border border-green-100" data-id="element-3923">
                <h3 className="text-xl font-bold text-blue-900 mb-4 flex items-center" data-id="element-3924">
                  <UsersIcon className="mr-2 h-6 w-6 text-green-700" data-id="element-3925" />
                  Regional Influence
                </h3>
                <p className="text-gray-700" data-id="element-3926">
                  Isonyin serves as headquarters for the league of Chief Imams
                  of 60 towns in the former Yemoji Local Government Area. This
                  designation highlights the town's significant role in regional
                  Islamic leadership and community organization.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Mosque Architecture Section */}
        <section className="mb-16" data-id="element-3927">
          <div className="text-center mb-10" data-id="element-3928">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3929">
              Architectural Heritage
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3930"></div>
          </div>
          <div className="bg-gradient-to-br from-green-50 to-white p-8 rounded-lg shadow-lg border border-green-100" data-id="element-3931">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-3932">
              <div data-id="element-3933">
                <h3 className="text-2xl font-bold text-green-800 mb-4" data-id="element-3934">
                  Evolution of Mosque Architecture
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-3935">
                  The architectural journey of Isonyin's mosques reflects the
                  growth and development of the Muslim community over more than
                  a century. From the first simple structure commissioned in
                  1908 to the magnificent modern Central Mosque commissioned in
                  2016, each building tells a story of faith, perseverance, and
                  community dedication.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-3936">
                  The current Central Mosque, with its distinctive twin
                  minarets, golden dome, and terracotta-colored facade,
                  represents not just a place of worship but a landmark that
                  serves as a beacon for the Muslim community in Isonyin and
                  surrounding areas.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-3937">
                  The mosque complex includes the main prayer hall, facilities
                  for ablution, and spaces for community gatherings, embodying
                  the vision of a modern Islamic center that serves both
                  spiritual and social needs.
                </p>
              </div>
              <div className="space-y-4" data-id="element-3938">
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-green-700" data-id="element-3939">
                  <h4 className="font-bold text-blue-900 mb-2" data-id="element-3940">
                    Distinctive Features
                  </h4>
                  <ul className="space-y-2 text-gray-700" data-id="element-3941">
                    <li className="flex items-start" data-id="element-3942">
                      <div className="h-5 w-5 text-green-700 mr-2 mt-0.5" data-id="element-3943">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3944">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3945" />
                        </svg>
                      </div>
                      <span data-id="element-3946">
                        Twin minarets reaching towards the sky, symbolizing the
                        connection between earth and heaven
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-3947">
                      <div className="h-5 w-5 text-green-700 mr-2 mt-0.5" data-id="element-3948">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3949">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3950" />
                        </svg>
                      </div>
                      <span data-id="element-3951">
                        Golden dome crowned with the crescent, a universal
                        symbol of Islam
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-3952">
                      <div className="h-5 w-5 text-green-700 mr-2 mt-0.5" data-id="element-3953">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3954">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3955" />
                        </svg>
                      </div>
                      <span data-id="element-3956">
                        Arched windows providing natural light and ventilation
                        throughout the prayer hall
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-3957">
                      <div className="h-5 w-5 text-green-700 mr-2 mt-0.5" data-id="element-3958">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3959">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3960" />
                        </svg>
                      </div>
                      <span data-id="element-3961">
                        Spacious prayer hall accommodating hundreds of
                        worshippers
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="bg-green-800 text-white p-6 rounded-lg" data-id="element-3962">
                  <p className="italic" data-id="element-3963">
                    "The Central Mosque stands as a monument to the faith,
                    unity, and dedication of the Isonyin Muslim community,
                    serving not just as a place of worship but as a center for
                    Islamic education and community development."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Islamic Education Section */}
        <section className="mb-16" data-id="element-3964">
          <div className="text-center mb-10" data-id="element-3965">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3966">
              Islamic Education in Isonyin
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3967"></div>
          </div>
          <div className="bg-blue-900 text-white p-8 rounded-lg" data-id="element-3968">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-3969">
              <div data-id="element-3970">
                <h3 className="text-2xl font-bold mb-4" data-id="element-3971">
                  Evolution of Muslim Education
                </h3>
                <p className="mb-4 leading-relaxed" data-id="element-3972">
                  The early Muslims considered Western Education as a veritable
                  tool for conversion of Muslims to the Christian faith.
                  Consequently, for quite a long time, Muslims and their wards
                  concentrated on Quranic education to the exclusion of Western
                  Education.
                </p>
                <p className="mb-4 leading-relaxed" data-id="element-3973">
                  When eventually the Muslims decided to send their children to
                  school, the only choice was Emmanuel Primary School. This was
                  the situation until 1955 when Erodo Moslem Primary School was
                  established by Moslem communities of Isonyin, Odosenlu and
                  Odoregbe.
                </p>
                <p className="leading-relaxed" data-id="element-3974">
                  The Muslim community currently has the central mosque building
                  built between 1909 and 1911 and three zonal mosques
                  (Rattibis). There is a Moslem Primary School and a make shift
                  Islamic school for the acquisition of Islamic Koranic
                  education.
                </p>
              </div>
              <div className="bg-blue-800 p-6 rounded-lg" data-id="element-3975">
                <div className="flex items-center mb-4" data-id="element-3976">
                  <GraduationCapIcon className="h-6 w-6 text-yellow-400 mr-3" data-id="element-3977" />
                  <h4 className="text-xl font-bold" data-id="element-3978">Educational Development</h4>
                </div>
                <ul className="space-y-3 text-blue-100" data-id="element-3979">
                  <li className="flex items-start" data-id="element-3980">
                    <div className="h-5 w-5 text-yellow-400 mr-2 mt-0.5" data-id="element-3981">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3982">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3983" />
                      </svg>
                    </div>
                    <div data-id="element-3984">Initial focus on Quranic education exclusively</div>
                  </li>
                  <li className="flex items-start" data-id="element-3985">
                    <div className="h-5 w-5 text-yellow-400 mr-2 mt-0.5" data-id="element-3986">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3987">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3988" />
                      </svg>
                    </div>
                    <div data-id="element-3989">Gradual acceptance of Western education</div>
                  </li>
                  <li className="flex items-start" data-id="element-3990">
                    <div className="h-5 w-5 text-yellow-400 mr-2 mt-0.5" data-id="element-3991">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3992">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3993" />
                      </svg>
                    </div>
                    <div data-id="element-3994">
                      Establishment of Erodo Moslem Primary School in 1955
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-3995">
                    <div className="h-5 w-5 text-yellow-400 mr-2 mt-0.5" data-id="element-3996">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3997">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3998" />
                      </svg>
                    </div>
                    <div data-id="element-3999">First Koranic teacher was Alfa Sambo from Ilorin</div>
                  </li>
                  <li className="flex items-start" data-id="element-4000">
                    <div className="h-5 w-5 text-yellow-400 mr-2 mt-0.5" data-id="element-4001">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-4002">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-4003" />
                      </svg>
                    </div>
                    <div data-id="element-4004">
                      Current plans for a modern Islamic school in the Central
                      Mosque Complex
                    </div>
                  </li>
                </ul>
                <div className="mt-4 pt-4 border-t border-blue-700" data-id="element-4005">
                  <p className="italic text-blue-100" data-id="element-4006">
                    "The foregoing scenario thus clearly illustrates the crying
                    and urgent need for a modern and befitting Central Mosque in
                    Isonyin. And to make the task of propagation and
                    consolidation of Islam less intractable, it has been decided
                    to include the construction of a mult-purpose hall, an
                    Islamic School and a mini-clinic in the Central Mosque
                    Complex."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Chief Imams Section */}
        <section className="mb-16" data-id="element-4007">
          <div className="text-center mb-10" data-id="element-4008">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-4009">
              Chief Imams of Isonyin
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-4010"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-4011">
              The spiritual leaders who have guided the Muslim community of
              Isonyin through its history.
            </p>
          </div>
          <div className="overflow-x-auto" data-id="element-4012">
            <table className="min-w-full bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-4013">
              <thead className="bg-green-800 text-white" data-id="element-4014">
                <tr data-id="element-4015">
                  <th className="py-3 px-4 text-left" data-id="element-4016">No.</th>
                  <th className="py-3 px-4 text-left" data-id="element-4017">Name</th>
                  <th className="py-3 px-4 text-left" data-id="element-4018">Origin</th>
                  <th className="py-3 px-4 text-left" data-id="element-4019">Period</th>
                </tr>
              </thead>
              <tbody data-id="element-4020">
                {chiefImams.map((imam, index) => <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-4021">
                    <td className="py-3 px-4 border-b border-gray-200" data-id="element-4022">
                      {index + 1}
                    </td>
                    <td className="py-3 px-4 border-b border-gray-200 font-medium" data-id="element-4023">
                      {imam.name}
                    </td>
                    <td className="py-3 px-4 border-b border-gray-200" data-id="element-4024">
                      {imam.origin}
                    </td>
                    <td className="py-3 px-4 border-b border-gray-200" data-id="element-4025">
                      <div className="flex items-center" data-id="element-4026">
                        <CalendarIcon className="h-4 w-4 mr-2 text-green-700" data-id="element-4027" />
                        {imam.period}
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <div className="mt-6 text-center text-gray-600 italic" data-id="element-4028">
            <p data-id="element-4029">
              The first Koranic teacher was Alfa Sambo from Ilorin. He served
              during the era of the first Chief Imam.
            </p>
          </div>
        </section>
        {/* Central Mosque Development Section */}
        <section className="mb-16" data-id="element-4030">
          <div className="text-center mb-10" data-id="element-4031">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-4032">
              Development of the Central Mosque
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-4033"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-4034">
            <div className="order-2 md:order-1" data-id="element-4035">
              <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-4036">
                A Century of Growth and Development
              </h3>
              <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-4037">
                The Muslim community in Isonyin has seen the development of
                three successive central mosques over more than a century. Each
                new mosque has represented the growth and evolution of the
                Islamic community in the town.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-4038">
                The first Isonyin Central mosque was commissioned in 1908,
                marking the formal establishment of Islamic worship in the town.
                As the community grew, a second Central Mosque was constructed,
                beginning in 1911 and commissioned in 1928.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-4039">
                The current Central Mosque represents the continued growth and
                vitality of the Muslim community. Fund raising for this third
                mosque took place in December 1997, with the foundation laying
                ceremony following in July 1998. After years of dedicated
                community effort, the mosque was commissioned on July 23rd,
                2016.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-4040">
                Today, this magnificent structure with its twin minarets and
                golden dome serves as a spiritual home for Muslims in Isonyin
                and surrounding communities, hosting daily prayers, Friday Jumat
                services, and special occasions like Eid celebrations.
              </p>
              <div className="mt-6" data-id="element-4041">
                <Button href="/contact" variant="secondary" data-id="element-4042">
                  Contact for More Information
                </Button>
              </div>
            </div>
            <div className="order-1 md:order-2 bg-green-50 p-8 rounded-lg shadow-md" data-id="element-4043">
              <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-4044">
                Mosque Development Timeline
              </h3>
              <div className="space-y-6" data-id="element-4045">
                {mosqueMilestones.map((milestone, index) => <div key={index} className="flex" data-id="element-4046">
                    <div className="flex-shrink-0 w-28 font-bold text-green-800" data-id="element-4047">
                      {milestone.year}
                    </div>
                    <div className="flex-grow pl-4 border-l-2 border-green-200" data-id="element-4048">
                      <p className="text-gray-700" data-id="element-4049">{milestone.event}</p>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </section>
        {/* Current Status Section */}
        <section data-id="element-4050">
          <div className="bg-gradient-to-r from-green-800 to-green-700 text-white rounded-lg overflow-hidden" data-id="element-4051">
            <div className="container mx-auto px-4 py-12" data-id="element-4052">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-4053">
                <div data-id="element-4054">
                  <h2 className="text-3xl font-bold mb-4" data-id="element-4055">
                    The Muslim Community Today
                  </h2>
                  <p className="mb-6 leading-relaxed" data-id="element-4056">
                    Today, the Muslim community in Isonyin continues to thrive
                    and contribute significantly to the town's social and
                    cultural landscape. Despite being a minority at 25% of the
                    population, Muslims have maintained a strong presence and
                    influence in the region.
                  </p>
                  <p className="mb-6 leading-relaxed" data-id="element-4057">
                    The community maintains the magnificent Central Mosque and
                    three zonal mosques (Rattibis). Plans for further
                    development include a multi-purpose hall, an Islamic School,
                    and a mini-clinic as part of the Central Mosque Complex,
                    highlighting the community's vision for the future.
                  </p>
                  <div data-id="element-4058">
                    <Button href="/about" variant="outline" className="border-white text-white hover:bg-white/10" data-id="element-4059">
                      Learn More About Isonyin History
                    </Button>
                  </div>
                </div>
                <div className="relative" data-id="element-4060">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/t8G9CzciASfCeNchUAs1Rz/WhatsApp_Image_2025-11-07_at_19.20.07_%281%29.jpg" alt="Isonyin Central Mosque Minarets" className="rounded-lg shadow-lg" data-id="element-4061" />
                  <div className="absolute -bottom-4 -right-4 bg-yellow-500 text-green-900 font-bold py-2 px-4 rounded-lg transform rotate-3 shadow-lg" data-id="element-4062">
                    Faith & Community
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>;
};
export default IslamicReligion;